import { GoogleAnalytics } from '@next/third-parties/google';
import type { JSX } from 'react';

export default function Google(): JSX.Element | null {
  const isProd: boolean = process.env.CURRENT_ENV === 'production';

  if (!isProd) return null;

  // const gtmId = process.env.TOWN_WEB_GTM_ID;
  const gaId = process.env.TOWN_WEB_GA_ID;

  // if (!gtmId || !gaId) {
  if (!gaId) {
    // console.warn('Google Analytics 또는 Tag Manager ID가 설정되지 않았습니다.');
    console.warn('Google Analytics가 설정되지 않았습니다. ID 확인.');
    return null;
  }

  return (
    <>
      {/* <GoogleTagManager gtmId={gtmId} /> */}
      <GoogleAnalytics gaId={gaId} />
      {/* <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${gaId}', {
                'send_page_view': false,               
              });
            `,
        }}
      /> */}
    </>
  );
}

export const handleSendGAEvent = (event_name: 'page_view' | string, event_parameters: object) => {
  if (process.env.CURRENT_ENV !== 'production' || typeof window.gtag === 'undefined') return;
  window.gtag('event', event_name, event_parameters);
};
